<template>
  <div class="tab-container" >
    <el-tabs
      class="tab-container-root"
      v-model="currentTabName"
    >
      <el-tab-pane
        label="基本信息"
        name="basic"
      >
        <el-form
          v-form
          data-vv-scope="tenantManageForm"
        >
          <eco-form-item
            label="租户类型"
            label-width="120px"
            v-if="tenantId"
          >
            <eco-select
              class="ht"
              v-model="tenantManage.typeId"
              :options="tenantTypeList"
              :props="{ key: 'id', value: 'name' }"
              validate="required"
            />
          </eco-form-item>
          <eco-form-item
            label="租户名称"
            label-width="120px"
          >
            <eco-input
              v-model="tenantManage.name"
              validate="required"
              autocomplete="off"
            />
            <el-tooltip
              class="item"
              effect="dark"
              content="租户名称会作为登录页的公司名称"
              placement="right-start"
            >
              <span
                class="el-icon-question"
                style="margin-left: 10px"
              ></span>
            </el-tooltip>
          </eco-form-item>
          <eco-form-item
            label="租户别名"
            label-width="120px"
          >
            <eco-input
              v-model="tenantManage.code"
              autocomplete="off"
              :validate="{
                regex: {
                  exp: '^[a-z]{0,10}\\d{0,3}$',
                  message:
                    '租户别名只能包含小写字母和数字，且必须以小写字母开头，小写字母最多10个，数字最多3个'
                },
                required: true,
                isExist: '${uc}/uc/tenantManage/v1/checkCode?code='
              }"
              :disabled="tenantManage.id ? true : false"
            />
            <el-tooltip
              class="item"
              effect="dark"
              content="租户别名只能包含小写字母和数字，且必须以小写字母开头，小写字母最多10个，数字最多3个"
              placement="right-start"
            >
              <span
                class="el-icon-question"
                style="margin-left: 10px"
              ></span>
            </el-tooltip>
          </eco-form-item>
          <eco-form-item
            label="租户简称"
            label-width="120px"
          >
            <eco-input
              v-model="tenantManage.shorthand"
              validate="required"
            />
          </eco-form-item>
          <eco-form-item
            v-if="tenantId"
            label="状态"
            label-width="120px"
          >
            <eco-select
              v-model="tenantManage.status"
              :options="
                tenantManage.status == 'draft' ? draftOptions : statusOpition
              "
              :validate="{ required: true }"
            />
          </eco-form-item>
          <eco-form-item
            label="访问地址"
            label-width="120px"
            v-if="tenantManage.id && tenantManage.id != '-1'"
          >
            <el-link
              type="primary"
              @click="showCopyUrl"
            >查看地址</el-link>
          </eco-form-item>
          <eco-form-item
            label="私有化域名"
            label-width="120px"
            v-if="tenantManage.typeId === '1667050843714904064'"
          >
            <eco-input
              v-model="tenantManage.domain"
              :validate="{
                required: false
              }"
            />
            <el-tooltip
              class="item"
              effect="dark"
              content="请输入正确的域名地址，例如http://abc.abc.com ｜ http://abc.abc.com:8888"
              placement="right-start"
            >
              <span
                class="el-icon-question"
                style="margin-left: 10px"
              ></span>
            </el-tooltip>
          </eco-form-item>
          <eco-form-item
            label="管理端LOGO"
            label-width="120px"
          >
            <FeFileToUpload
              ref="manageLogo"
              model-name="tenantManage.manageLogo"
              :accept="`.jpg,.jpeg,.png,.JPG,.JPEG`"
              :limit="1"
              :multiple="false"
            >
            </FeFileToUpload>
          </eco-form-item>
          <eco-form-item
            label="用户端LOGO"
            label-width="120px"
          >
            <FeFileToUpload
              ref="frontLogo"
              model-name="tenantManage.frontLogo"
              :accept="`.jpg,.jpeg,.png,.JPG,.JPEG`"
              :limit="1"
              :multiple="false"
            >
            </FeFileToUpload>
          </eco-form-item>
          <eco-form-item
            label="登录页LOGO"
            label-width="120px"
          >
            <FeFileToUpload
              ref="ico"
              model-name="tenantManage.ico"
              :accept="`.jpg,.jpeg,.png,.JPG,.JPEG`"
              :limit="1"
              :multiple="false"
            >
            </FeFileToUpload>
          </eco-form-item>
          <eco-form-item
            label="工地看板banner"
            label-width="120px"
          >
            <FeFileToUpload
              ref="conSeeBoardBanner"
              isDefaultText="isDefaultText"
              model-name="tenantManage.conSeeBoardBanner"
              :accept="`.jpg,.jpeg,.png,.JPG,.JPEG`"
              :limit="10"
              :multiple="false"
            >
            </FeFileToUpload>
          </eco-form-item>
          <eco-form-item
            label="工作台banner"
            label-width="120px"
          >
            <FeFileToUpload
              isDefaultText="isDefaultText"
              ref="stagingBanner"
              model-name="tenantManage.stagingBanner"
              :accept="`.jpg,.jpeg,.png,.JPG,.JPEG`"
              :limit="10"
              :multiple="false"
            >
            </FeFileToUpload>
          </eco-form-item>
          <eco-form-item
            label="描述"
            label-width="120px"
          >
            <eco-input
              type="textarea"
              v-model="tenantManage.desc"
              placeholder="请输入类型说明"
              :maxlength="300"
            />
          </eco-form-item>
          <eco-form-item
            label="首页问候语"
            label-width="120px"
          >
            <eco-input
              type="textarea"
              v-model="tenantManage.greetings"
              placeholder="请输入类型说明"
              :maxlength="50"
            />
          </eco-form-item>
        </el-form>
        <fe-submit-button
          :style="saveBtnStyle"
          url="${uc}/uc/tenantManage/v1/save"
          :model="tenantManage"
          style="margin: 20px 0 0 120px"
          scope-name="tenantManageForm"
          @before-save-data="beforeSaveData"
          @after-response-value="afterResponseValue"
        >保存基本信息</fe-submit-button>
      </el-tab-pane>
      <el-tab-pane
        label="银行信息"
        v-if="tenantManage.id && tenantManage.status != 'draft'"
        name="bankInfo"
      >
        <tenantBankInfoManager :tenantId="curSelectTenantId"></tenantBankInfoManager>
      </el-tab-pane>
      <el-tab-pane
        label="法人机构"
        v-if="tenantManage.id && tenantManage.status != 'draft'"
        name="corporateInfo"
      >
        <tenantCorporateInfoManager :tenantId="curSelectTenantId"></tenantCorporateInfoManager>
      </el-tab-pane>
      <!-- <el-tab-pane
        label="扩展信息"
        v-if="tenantManage.id && tenantManage.status != 'draft'"
        name="params"
      >
        <el-form v-form data-vv-scope="tenantParam" class="user-param-form">
          <template v-for="param in tenantParams">
            <eco-form-item
              :label="param.name"
              prop="name"
              label-width="220px"
              :key="param.name"
            >
              <el-date-picker
                v-model="tenantParam[param.code]"
                type="datetime"
                placeholder="选择日期时间"
                v-if="param.ctlType === 'date'"
              ></el-date-picker>
              <eco-input
                v-model="tenantParam[param.code]"
                v-if="param.ctlType === 'input'"
              />
              <eco-input
                type="number"
                v-model="tenantParam[param.code]"
                v-if="param.ctlType === 'number'"
              />
              <eco-select
                v-model="tenantParam[param.code]"
                v-if="param.ctlType === 'select'"
                :options="JSON.parse(param.json)"
              />
              <eco-radio
                v-model="tenantParam[param.code]"
                v-if="param.ctlType === 'radio'"
                :options="JSON.parse(param.json)"
              />
              <eco-checkbox
                v-model="tenantParam[param.code]"
                v-if="param.ctlType === 'checkbox'"
                :options="JSON.parse(param.json)"
              />
            </eco-form-item>
          </template>
        </el-form>
        <el-button
          :style="saveBtnStyle"
          type="primary"
          @click="tenantParamSubmit"
          >保存扩展信息</el-button
        >
      </el-tab-pane> -->
      <el-tab-pane
        label="邮件设置"
        name="mailService"
        v-if="tenantManage.id && tenantManage.status != 'draft'"
      >
      <div>
        <tenant-mail-server-manager
          ref="tenantMailServerManager"
          :tenantId="curSelectTenantId"
        ></tenant-mail-server-manager>
      </div>
        <el-button
          :style="saveBtnStyle"
          type="primary"
          style="margin: 20px 0 0 180px"
          @click="saveTenantMail"
        >保存邮件信息</el-button>
      </el-tab-pane>
      <el-tab-pane
        label="用户初始密码"
        name="userService"
        v-if="tenantManage.id && tenantManage.status != 'draft'"
      >
        <tenant-user-server-manager
          ref="tenantUserServerManager"
          :tenantId="curSelectTenantId"
        ></tenant-user-server-manager>
      </el-tab-pane>
      <!--      <el-tab-pane-->
      <!--        label="用户计费"-->
      <!--        v-if="tenantManage.id && tenantManage.status != 'draft'"-->
      <!--        name="userCost"-->
      <!--      >-->
      <!--        <UserCostManager :tenantId="curSelectTenantId"></UserCostManager>-->
      <!--      </el-tab-pane>-->
      <!--<el-tab-pane
        label="流程配置"
        v-if="tenantManage.id && tenantManage.status != 'draft'"
        name="flowConfig"
      >
        <tenantFlowConfigManager
          :tenantId="curSelectTenantId"
        ></tenantFlowConfigManager>
      </el-tab-pane>
      <el-tab-pane
          label="业务规则"
          v-if="tenantManage.id && tenantManage.status != 'draft'"
          name="ruleConfig"
      >
        <ruleConfigManager :tenantId="curSelectTenantId"></ruleConfigManager>
      </el-tab-pane>-->
    </el-tabs>
    <!-- 租户访问地址 -->
    <tenant-access-address ref="tenantAccessAddress"></tenant-access-address>
  </div>
</template>
<script>
const FeFileToUpload = () => import('@/components/common/FeFileToUpload.vue')
const UserCostManager = () => import('@/components/tenant/UserCostManager2.vue')
const tenantMailServerManager = () => import('@/components/tenant/TenantMailServerManager.vue')
const tenantUserServerManager = () => import('@/components/tenant/TenantUserServerManager.vue')
const tenantAccessAddress = () => import('@/components/tenant/TenantAccessAddress.vue')
const tenantBankInfoManager = () => import('@/components/tenant/TenantBankInfoManager.vue')
const tenantCorporateInfoManager = () => import('@/components/tenant/TenantCorporateInfoManager.vue')
const tenantFlowConfigManager = () => import('@/components/tenant/TenantFlowConfigManager.vue')
const ruleConfigManager = () => import('@/components/tenant/RuleConfigManager.vue')

export default {
  name: 'tenantInfoManager',
  props: ['tenantId', 'currentTabNames'],
  components: {
    FeFileToUpload,
    tenantMailServerManager,
    tenantAccessAddress,
    tenantBankInfoManager,
    tenantCorporateInfoManager,
    tenantUserServerManager,
    UserCostManager,
    tenantFlowConfigManager,
    ruleConfigManager
  },
  data() {
    return {
      currentTabName: 'basic',
      dialogVisible: false,
      tenantManage: {
        status: 'draft',
        typeId: '',
        name: '',
        shorthand: '',
        greetings: ''
      },
      curSelectTenantId: '',
      tenantTypeList: [],
      tenantParam: {}, //当前租户的参数值
      tenantParams: [], //系统的所有组合类型参数
      saveBtnStyle: 'z-index: 15000;',
      draftOptions: [
        { key: 'draft', value: '草稿' },
        { key: 'enable', value: '启用' },
        { key: 'disabled', value: '禁用' }
      ],
      statusOpition: [
        { key: 'enable', value: '启用' },
        { key: 'disabled', value: '禁用' }
      ]
    }
  },
  mounted() {
    if (this.currentTabNames) {
      this.currentTabName = this.currentTabNames
    }
    if (this.$route.params.active) this.currentTabName = this.$route.params.active
    this.$validator = this.$root.$validator
    this.curSelectTenantId = this.tenantId
    if (!this.tenantId) {
      this.saveBtnStyle = 'z-index: 15000;'
      this.curSelectTenantId = this.$store.state.login.currentUser.tenantId
    }
    if (this.curSelectTenantId == 'add') {
      this.curSelectTenantId = ''
      this.getTenantTypeList()
    }
    let url = '${uc}/uc/tenantManage/v1/getJson?id=' + this.curSelectTenantId
    if (this.curSelectTenantId) {
      let _this = this
      this.$http.get(url).then(
        (resp) => {
          _this.tenantManage = Object.assign(_this.tenantManage, resp.data)
          _this.tenantManage.greetings = _this.tenantManage.greetings ? _this.tenantManage.greetings : 'Hi，你好！欢迎进入易筑数字化项目管理平台'
          setTimeout(function () {
            if (_this.tenantManage.manageLogo) {
              _this.$refs.manageLogo.setFiles(JSON.parse(_this.tenantManage.manageLogo))
            }
            if (_this.tenantManage.frontLogo) {
              _this.$refs.frontLogo.setFiles(JSON.parse(_this.tenantManage.frontLogo))
            }
            if (_this.tenantManage.ico) {
              _this.$refs.ico.setFiles(JSON.parse(_this.tenantManage.ico))
            }
            if (_this.tenantManage.conSeeBoardBanner) {
              _this.$refs.conSeeBoardBanner.setFiles(JSON.parse(_this.tenantManage.conSeeBoardBanner))
            }
            if (_this.tenantManage.stagingBanner) {
              _this.$refs.stagingBanner.setFiles(JSON.parse(_this.tenantManage.stagingBanner))
            }
          }, 1000)
          this.getTenantTypeList()
          this.initTenantParams()
        },
        (error) => {
          reject(error)
        }
      )
    }
  },
  methods: {
    getTenantTypeList() {
      let that = this
      this.$store.dispatch('tenant/actionTenantId', null)
      this.$http
        .get('${uc}/uc/tenantType/v1/getAll?status=enable')
        .then(
          (resp) => {
            that.tenantTypeList = resp.data
            that.$store.dispatch('tenant/actionTenantId', that.tenantId)
          },
          (error) => {
            that.$store.dispatch('tenant/actionTenantId', that.tenantId)
            reject(error)
          }
        )
        .then(() => {
          if (!that.curSelectTenantId) {
            let list = that.tenantTypeList.filter((item) => item.isDefault === '1')
            that.$set(this.tenantManage, 'typeId', list[0].id)
          }
        })
    },
    //初始化租户扩展参数
    initTenantParams() {
      let that = this
      if (this.tenantManage.id) {
        this.$store.dispatch('tenant/actionTenantId', null)
        this.$http
          .get('${uc}/api/params/v1/tenantParams/getTenantParams?tenantTypeId=' + this.tenantManage.typeId)
          .then((resp) => {
            that.tenantParams = resp.data
            return resp.data
          })
          .then((params) => {
            if (!params || params.constructor != Array || params.length < 1) {
              return
            }
            this.$http.get('${uc}/uc/tenantParams/v1/getParamsValue?tenantId=' + that.tenantManage.id).then((response) => {
              if (response.data && response.data.constructor == Array) {
                response.data.forEach((r) => {
                  that.$set(that.tenantParam, r['code'], r['value'])
                })
              }
              that.$store.dispatch('tenant/actionTenantId', that.tenantId)
            })
          })
      }
    },
    tenantParamSubmit() {
      var data = []
      let tenantParam = this.tenantParam
      for (let _param in tenantParam) {
        if (tenantParam.hasOwnProperty(_param)) {
          data.push({ alias: _param, value: this.tenantParam[_param] })
        }
      }
      let _this = this
      if (data.length > 0) {
        this.$http.post('${uc}/uc/tenantParams/v1/saveTenantParams?tenantId=' + this.tenantManage.id, data).then(
          (resp) => {
            let response = resp.data
            if (!response.state) {
              _this.$message.error(response.message)
            } else {
              _this.$message.success(response.message)
            }
          },
          (error) => {
            reject(error)
          }
        )
      }
    },
    beforeSaveData() {
      if (this.$refs.manageLogo.getFiles() != '') {
        this.tenantManage.manageLogo = JSON.stringify(this.$refs.manageLogo.getFiles())
      }
      if (this.$refs.frontLogo.getFiles() != '') {
        this.tenantManage.frontLogo = JSON.stringify(this.$refs.frontLogo.getFiles())
      }
      if (this.$refs.ico.getFiles() != '') {
        this.tenantManage.ico = JSON.stringify(this.$refs.ico.getFiles())
      }
      if (this.$refs.stagingBanner.getFiles() != '') {
        this.tenantManage.stagingBanner = JSON.stringify(this.$refs.stagingBanner.getFiles())
      }
      if (this.$refs.conSeeBoardBanner.getFiles() != '') {
        this.tenantManage.conSeeBoardBanner = JSON.stringify(this.$refs.conSeeBoardBanner.getFiles())
      }
    },
    afterResponseValue(value) {
      if (this.tenantId == 'add') {
        this.tenantManage.id = value
        this.$emit('after-add-success', this.tenantManage)
      }
    },
    saveTenantMail() {
      this.$refs.tenantMailServerManager.saveData()
    },
    saveTenantUser() {
      this.$refs.tenantUserServerManager.saveData()
    },
    showCopyUrl() {
      this.$refs.tenantAccessAddress.showDialog(this.tenantManage.code)
    }
  }
}
</script>

<style lang="scss" scoped>
.sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
  height: calc(100% - 170px);
}

div.tab-container-root /deep/ > .el-tabs__content {
  height: calc(100% - 60px);
}

.tab-container {
  height: 100%;
  padding: 0 20px  !important;
  overflow: hidden;
}
.tab-container .tab-container-root {
 height: 100%;
  overflow: hidden;
}
.tab-container .tab-container-root .eco-table {
  height: 100%;
  overflow: auto;
}
.tab-container .tab-container-root .el-tabs__content .el-tab-pane {
  height: calc(100% - 20px);
  overflow: auto;
}
.el-drawer__open .el-drawer.rtl {
  -webkit-animation: rtl-drawer-in 0.3s 1ms;
  animation: rtl-drawer-in 0.3s 1ms;
  overflow: auto;
}
</style>
